export const projects =
        [
          // {
          //   "key": "trucktrack",
          //   "name": "Truck Track",
          //   "img": "https://res.cloudinary.com/doddfudab/image/upload/v1557068154/rtds_work/truck%20track/Untitled-1-01.png",
          //   "path": "/work/trucktrack",
          //   "category":["websystem"],
          //   "desc": "Truck Track Application tracks your trucks for efficient delivery and errands",
          //   "photos": [
          //     {
          //       src: "https://res.cloudinary.com/doddfudab/image/upload/v1557068045/rtds_work/truck%20track/12163.jpg"
          //     }
          //   ],
          //   "features": [
          //     {
          //       id: 1,
          //       desc:
          //         "This system checks status of trucks whether it's in transit or not. In transit trucks can be tracked individually or not live in maps.",
          //       img:
          //         "https://res.cloudinary.com/doddfudab/image/upload/v1557069411/rtds_work/truck%20track/Truck_Tracker-01.png"
          //     }
          //   ]
          // },
          {
            "key": "radiantskin",
            "name": "Radiant Skin",
            "img": "https://res.cloudinary.com/doddfudab/image/upload/v1555412765/rtds_work/TOP%20water/rad-03.jpg",
            "path": "/work/radiantskin",
            "category":["branding","illustrate","layout","websystem"],
            "desc": "Personalize your facial care with Radiant Skin! Radiant Skin gives the best facial care for men and women.",
            "photos": [
              {
                src: "https://res.cloudinary.com/doddfudab/image/upload/v1555412765/rtds_work/TOP%20water/rad-03.jpg"
              }
            ],
            "features": [
              {
                id: 1,
                desc:
                  "We've provide Radiant Skin their own system to help them track their customers needs and provide even better services yet!",
                img:
                  "https://res.cloudinary.com/doddfudab/image/upload/v1555228804/rtds_work/webmosystems/RS-f-1.jpg"
              },
              {
                id: 2,
                desc:
                  "New client? No need to fil up hassle long information sheets for records. They can automate your account so the next time you visit them they know exactly what’s for you!",
                img:
                  "https://res.cloudinary.com/doddfudab/image/upload/v1555228802/rtds_work/webmosystems/RS-f-2-02.png"
              }
            ]
          },
          {
            "key": "bayongbags",
            "name": "Bayong Bags USA",
            "img": "https://res.cloudinary.com/doddfudab/image/upload/v1555407761/rtds_work/Bayong%20Bags/bayongbags-photos-03.jpg",
            "path": "/work/bayongbags",
            "category":["branding","illustrate","layout","photography","websystem"],
            "desc": "Bayong Bags USA is an authorized reseller of handcrafted and beautifully painted bayong bags.",
            "photos": [
                // {
                //   src: "https://res.cloudinary.com/doddfudab/image/upload/v1554736594/rtds_work/Bayong%20Bags/Bayong-Bags-Ig.jpg",
                //   width: 3,
                //   height: 3
                // },
                {
                  src: "https://res.cloudinary.com/doddfudab/image/upload/v1555407165/rtds_work/Bayong%20Bags/BB_USA_Ad_ver2.jpg",
                  width: 3,
                  height: 3
                },
                {
                  src: "https://res.cloudinary.com/doddfudab/image/upload/v1555407485/rtds_work/Bayong%20Bags/bayongbags-photos-02.jpg",
                  width: 5,
                  height: 3
                }
              ],
            // "features": [
            //   {
            //     id: 1,
            //     desc:
            //       "With their new system they track their stocks with their own mobile inventory system made by truly yours!",
            //     img:
            //       "https://res.cloudinary.com/doddfudab/image/upload/v1555235298/rtds_work/webmosystems/bbu-f-1.jpg"
            //   },
            //   {
            //     id: 2,
            //     desc:
            //       "At any time they can check their stocks and add products if they got a new design! Selling bayong bags has never been so easy.",
            //     img:
            //       "https://res.cloudinary.com/doddfudab/image/upload/v1555235291/rtds_work/webmosystems/BBU-F-2-02.png"
            //   }
            // ]
        },
      //   {
      //     "key": "topwater",
      //     "name": "TOP water",
      //     "img": "https://res.cloudinary.com/doddfudab/image/upload/v1555408624/rtds_work/TOP%20water/top-water-bottle-03.jpg",
      //     "path": "/work/topwater",
      //     "category":["illustrate","websystem"],
      //     "desc": "TOP Water gives you the the purest and cleanliest wate! Top of their services and their technology as well.",
      //     "photos": [
      //         {
      //           src: "https://res.cloudinary.com/doddfudab/image/upload/v1555408624/rtds_work/TOP%20water/top-water-bottle-03.jpg",
      //           width: 5,
      //           height: 3
      //         }
      //       ],
      //     "features": [
      //       {
      //         id: 1,
      //         desc:
      //           "Redtomato Design Studio having to provide them the user friendly purchasing order system ever.",
      //         img:
      //           "https://res.cloudinary.com/doddfudab/image/upload/v1555335238/rtds_work/webmosystems/tw-f-1.jpg"
      //       },
      //       {
      //         id: 2,
      //         desc:
      //           "With just a few clicks they can conviniently take orders, have an overview of their their inventory and sales, and check its records.",
      //         img:
      //           "https://res.cloudinary.com/doddfudab/image/upload/v1555335238/rtds_work/webmosystems/tw-f-2.png"
      //       },
      //       {
      //         id: 3,
      //         desc:
      //           "Great for monitoring you water station wherever you are! Easy for anyone to learn how to operate it and most importantly perfect for TOP water station.",
      //         img:
      //           "https://res.cloudinary.com/doddfudab/image/upload/v1555335239/rtds_work/webmosystems/tw-f-3.png"
      //       }
      //     ]
      // },
      {
        "key": "sweetsandtho",
        "name": "Sweets and Tho",
        "img": "https://res.cloudinary.com/doddfudab/image/upload/v1555412778/rtds_work/TOP%20water/Sweets-and-to-03.jpg",
        "path": "/work/sweetsandtho",
        "category":["branding","illustrate","websystem"],
        "desc": "Sweets and Tho offers the most luxurios and delicious sweets ever!",
        "photos": [
          {
            src: "https://res.cloudinary.com/doddfudab/image/upload/v1555412778/rtds_work/TOP%20water/Sweets-and-to-03.jpg"
          }
        ],
        "features": [
          {
            id: 1,
            desc:
              "Every bite here is remarkable and just to serve you better they just had their own purchasing order system.",
            img:
              "https://res.cloudinary.com/doddfudab/image/upload/v1555323248/rtds_work/webmosystems/sat-f-1.jpg"
          },
          {
            id: 2,
            desc:
              "Taking orders from their customers has never been this cute and easy. With just the right amount of sweetness.",
            img:
              "https://res.cloudinary.com/doddfudab/image/upload/v1555323100/rtds_work/webmosystems/sat-f-2.jpg"
          },
          {
            id: 3,
            desc:
              "With its inventory management as well, Sweets and Tho can record every ingredient its sweets need so that it reflects right away to its production and inventory.",
            img:
              "https://res.cloudinary.com/doddfudab/image/upload/v1555323085/rtds_work/webmosystems/sat-f-3.jpg"
          }
        ]
      },
      {
        "key": "shoplefranz",
        "name": "Shop le Franz",
        "img": "https://res.cloudinary.com/doddfudab/image/upload/v1555410022/rtds_work/TOP%20water/shoplefranz-03.jpg",
        "path": "/work/shoplefranz",
        "category":["branding","illustrate","layout","photography","websystem"],
        "desc": "Shop le Franz is a personal shop where she sells her unused, brand new, and preloved items.",
        "photos": [
          {
            src: "https://res.cloudinary.com/doddfudab/image/upload/v1543074668/rtds_work/Shop%20le%20Franz/Shop-le-Franz-MockUp3.jpg",
            width: 3,
            height: 3
          },
          {
            src: "https://res.cloudinary.com/doddfudab/image/upload/v1543074665/rtds_work/Shop%20le%20Franz/Shop-le-Franz-MockUp2.jpg",
            width: 3,
            height: 3
          },
          {
            src: "https://res.cloudinary.com/doddfudab/image/upload/v1543074668/rtds_work/Shop%20le%20Franz/Shop-le-Franz-MockUp3.jpg",
            width: 3,
            height: 3
          },
          {
            src: "https://res.cloudinary.com/doddfudab/image/upload/v1543074662/rtds_work/Shop%20le%20Franz/Shop-le-Franz-MockUp6.jpg",
            width: 3,
            height: 3
          },
          {
            src: "https://res.cloudinary.com/doddfudab/image/upload/v1543074662/rtds_work/Shop%20le%20Franz/Shop-le-Franz-MockUp1.jpg",
            width: 3,
            height: 3
          },
          {
            src: "https://res.cloudinary.com/doddfudab/image/upload/v1543074662/rtds_work/Shop%20le%20Franz/Shop-le-Franz-MockUp5.jpg",
            width: 3,
            height: 3
          },
          {
            src: "https://res.cloudinary.com/doddfudab/image/upload/v1543074660/rtds_work/Shop%20le%20Franz/Shop-le-Franz-MockUp4.jpg",
            width: 3,
            height: 3
          },
        ],
        "features": [
          {
            id: 1,
            desc:
              "With her own catalog she can have full control of its content.",
            img:
              "https://res.cloudinary.com/doddfudab/image/upload/v1555396958/rtds_work/webmosystems/slf-f-1.jpg"
          },
          {
            id: 2,
            desc:
              "A product catalog is a detailed list of the inventory of a store. This catalog contains all her for sale products showing its images, descriptions, specifications, price etc.",
            img:
              "https://res.cloudinary.com/doddfudab/image/upload/v1555396962/rtds_work/webmosystems/slf-f-2.jpg"
          },
          {
            id: 3,
            desc:
              "Each product is described properly and consistently. Even mall price is written so consumers will know what their money's worth!",
            img:
              "https://res.cloudinary.com/doddfudab/image/upload/v1555405596/rtds_work/webmosystems/slf-f-3.jpg"
          }
        ]
      },
      {
        "key": "jeanasdentistry",
        "name": "Jeana's Dentistry",
        "img": "https://res.cloudinary.com/doddfudab/image/upload/v1555410653/rtds_work/TOP%20water/jd-mock-03.jpg",
        "path": "/work/jeanasdentistry",
        "category":["illustrate","websystem"],
        "desc": "Jeana's Dentistry is a place where one can diagnose and treat dental issues and help patients develop better oral hygiene regimens. They clean teeth, correct bite issues, perform surgeries and extractions, and perform other duties to ensure that the teeth and mouth are healthy.",
        "photos": [
          {
            src: "https://res.cloudinary.com/doddfudab/image/upload/v1555410653/rtds_work/TOP%20water/jd-mock-03.jpg"
          }
        ],
        "features": [
          {
            id: 1,
            desc:
              "Jeana’s Dentistry only offers the best of their services now that they have the right technology with it!",
            img:
              "https://res.cloudinary.com/doddfudab/image/upload/v1555323085/rtds_work/webmosystems/jd-f-1.jpg"
          },
          {
            id: 2,
            desc:
              "No time can be wasted, the system can make sure no patient can be scheduled on the same time. So the patient can rest assured he/she will be served at his/her schedule.",
            img:
              "https://res.cloudinary.com/doddfudab/image/upload/v1555323088/rtds_work/webmosystems/jd-f-2-02.png"
          }
        ]
      }
      // ,
      // {
      //   "key": "washlab",
      //   "name": "Wash Lab",
      //   "img": "https://res.cloudinary.com/doddfudab/image/upload/v1555411004/rtds_work/TOP%20water/washlab-03.jpg",
      //   "path": "/work/washlab",
      //   "category":["illustrate","websystem"],
      //   "desc": "Wash Lab performs washing, drying, folding of drop-off laundry customers according to procedures.",
      //   "photos": [
      //     {
      //       src: "https://res.cloudinary.com/doddfudab/image/upload/v1555411004/rtds_work/TOP%20water/washlab-03.jpg"
      //     }
      //   ],
      //   "features": [
      //     {
      //       id: 1,
      //       desc:
      //         "We've provided Wash Lab their own purchasing system they can now give you a better means to wash your laundry!",
      //       img:
      //         "https://res.cloudinary.com/doddfudab/image/upload/v1555328606/rtds_work/webmosystems/wl-f-1.jpg"
      //     },
      //     {
      //       id: 2,
      //       desc:
      //         "Every entry of laundry gets reflected in real time with its task bar where they can monitor which tasks havent been pickedup. Moreover, get rid of wasteful and tedious paper works for receipt!",
      //       img:
      //         "https://res.cloudinary.com/doddfudab/image/upload/v1555328592/rtds_work/webmosystems/wl-f-2.png"
      //     }
      //   ]
      // }
      ,
      {
        "key": "racheenaparis",
        "name": "Racheen A Paris",
        "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542833384/rtds_work/Logo/RacheenAParisLogoMockup.jpg",
        "path": "/work/racheenaparis",
        "category":["branding","illustrate","layout","websystem"],
        "desc": "Racheen A Paris, a natural skin care brand designed to reach audiences of of different status and nationalities. Their products gives off a nice classy and authentic look as well as providing the best results that would appeal to different audiences. Redtomato Design Studio gave them the opportunity to start a new brand to suit their needs.",
        "photos": [
            {
              src: "https://res.cloudinary.com/doddfudab/image/upload/v1542883673/rtds_work/Racheen%20a%20Paris/Hanging-Wall-Sign-MockUp-4.jpg",
              width: 3,
              height: 3
            },
            {
              src: "https://res.cloudinary.com/doddfudab/image/upload/v1542873292/rtds_work/Racheen%20a%20Paris/01-Dispenser-Bottle-PSD-Mockup.jpg",
              width: 4,
              height: 3
            },
            {
              src: "https://res.cloudinary.com/doddfudab/image/upload/v1542873289/rtds_work/Racheen%20a%20Paris/Dropper-Bottle-Mockup.jpg",
              width: 3,
              height: 3
            },
            {
              src: "https://res.cloudinary.com/doddfudab/image/upload/v1542883951/rtds_work/Racheen%20a%20Paris/02-Dispenser-Bottle-PSD-Mockup.jpg",
              width: 5,
              height: 4
            },
            {
              src: "https://res.cloudinary.com/doddfudab/image/upload/v1542884376/rtds_work/Racheen%20a%20Paris/Hand-Sanitizer-Pump-Bottle-Mockup.jpg",
              width: 4,
              height: 4
            }
          ],
        "features":[
          {
            id: 1,
            desc:
              "What to be radiant and beautiful with no chemicals? Racheen A Paris offers you natural skincare and cosmetic products! With their advance inventory system, they can supervise product production and stocks anywhere at any time!",
            img:
              "https://res.cloudinary.com/doddfudab/image/upload/v1555244056/rtds_work/webmosystems/RaP-f-1.jpg"
          },
          {
            id: 2,
            desc:
              "Problem with your order? No worries! They can track your orders thru their purchasing system so you can rest assured that your order was taken and will be shipped right at your doorstep!",
            img:
              "https://res.cloudinary.com/doddfudab/image/upload/v1555244051/rtds_work/webmosystems/rap-f-2.png"
          }
        ]
    },
          {
                "key": "omg",
                "name": "Oil My Goodness",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1540401409/rtds_work/Logo/OMGLogoMockup.jpg",
                "path": "/work/omg",
                "category":["branding","illustrate","layout","photography","stickers"],
                "desc": "Oil My Goodness-OMG is an all-natural skincare brand that is here for one thing: to give people a better, healthier alternative. Since 2010, They have been an advocate of the power of mother nature when it comes to beauty. Having been exposed to numerous beauty products made with artificial and harmful chemicals, they realized that there is a pressing need for better options. OMG believes that the kindest thing that a person can do for himself/herself is to be a conscious buyer: someone who reads the label and refuses to use anything that could harm his/her body. After all, to choose an all-natural lifestyle is to make a stand for health and true wellness. Redtomato Design Studio helped them in their quest to spread natural skin care by rebranding their products in such a way that it would appeal to the users and gain much wider audience as of today. Stuck in the old, artificial beauty regimen for years? Be kind to yourself and let Mother Nature save your skin. Check out OMG today.",
                "photos": [
                    {
                      id: 1,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542876150/rtds_work/OMG/IMG_5037.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      id: 2,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540401409/rtds_work/Logo/OMGLogoMockup.jpg",
                      width: 3,
                      height: 2
                    },
                    {
                      id: 3,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540397891/rtds_work/Business%20Collaterals/OMG_LoyaltyCard-Mockup.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      id: 4,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540397891/rtds_work/Business%20Collaterals/OMG_LoyaltyCard-Mockup.jpg",
                      width: 4,
                      height: 4
                    },
                    {
                      id: 5,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540409958/rtds_work/Posters/OMG-Promo-MockUp.jpg",
                      width: 4,
                      height: 4
                    },
                    {
                      id: 6,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540401456/rtds_work/Stickers/OMG-Logo-Sticker-Mockup.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      id: 7,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540479551/rtds_work/Sticker%20Labels/OMG-Herbs-Rosemary-Mockup.jpg",
                      width: 4,
                      height: 4
                    },
                    {
                      id: 8,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540088409/rtds_work/label-group.png",
                      width: 4,
                      height: 3
                    },
                    {
                      id: 9,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540479552/rtds_work/Sticker%20Labels/OMG-Henna-Mockup.jpg",
                      width: 5,
                      height: 2
                    },
                    {
                      id: 10,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542829654/rtds_work/OMG/DSC_1344.png",
                      width: 4,
                      height: 3
                    },
                    {
                      id: 11,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542829689/rtds_work/OMG/DSC_1310.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      id: 12,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542829436/rtds_work/OMG/IMG_4951.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      id: 13,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542829426/rtds_work/OMG/IMG_5417.jpg",
                      width: 5,
                      height: 4
                    },
                    {
                      id: 14,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542829318/rtds_work/OMG/PocketBac/DSC_1130.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      id: 15,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542829310/rtds_work/OMG/PocketBac/DSC_1125.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      id: 16,
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542876134/rtds_work/OMG/DSC_1034.jpg",
                      width: 4,
                      height: 3
                    }
                  ],
                "features":[
                    {
                      id: 1,
                      desc:
                        "Season of Christmas has come? Don't fret, Redtomato Design Studio got you! We can create layouts for any events and season. Just ask away!",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1543051792/rtds_work/OMG%20Events/lipbalm_packaging2_withbleed-xmas.png"
                    },
                    {
                      id: 2,
                      desc:
                        "And you thought a good pose is only done by humans. It doesn't matter who or what, we'll capture it for you.",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1542829659/rtds_work/OMG/DSC_1301.png"
                    },
                    {
                      id: 3,
                      desc:
                        "You got a product to sell, have a neat container but don't have a good label? Let's slap that sticker to any packaging that you have. Customers will line-up to buy that product!",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1542869006/rtds_work/OMG/Labels%20Stickers/OMG-Henna-Mockup.jpg"
                    },
                    {
                      id: 4,
                      desc:
                        "Their products are made from fresh and natural ingredients mixed together to produce the desired natural goodness, which can also be seen in their brand logo.",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1542829426/rtds_work/OMG/IMG_5417.jpg"
                    }
                  ]
            },
            {
                "key": "eatsinthewest",
                "name": "Eats in the West",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542912509/rtds_work/Eats%20in%20the%20West/eatsinthemwest-logo-mock.jpg",
                "path": "/work/eatsinthewest",
                "category":["branding","layout","websystem"],
                "desc": "Eats in the west is a restaurant that has what the Filipino people craves for like American dishes as well as Filipino dishes. Best for families who wants to eat outside but can still have the taste of what home cooking is while having to eat variety of fast food dishes. Redtomato Design Studio gave them a new brand identity which includes their new logo to be used in their utensils and kitchen ware and other disposables. Craving for that Filipino cuisine but have kids around who wants to eat fast food?  Stop by on their restaurant, Eats in the West!",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542912509/rtds_work/Eats%20in%20the%20West/eatsinthemwest-logo-mock.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542896559/rtds_work/Eats%20in%20the%20West/menu-mockup001.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542896559/rtds_work/Eats%20in%20the%20West/menu-mockup0012.jpg",
                      width: 5,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542887168/rtds_work/Eats%20in%20the%20West/Poster-Frame-PSD-MockUp.jpg",
                      width: 4,
                      height: 4
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542896528/rtds_work/Eats%20in%20the%20West/FreeBurgerDrinkFastFoodSetNew.jpg",
                      width: 4,
                      height: 4
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542896543/rtds_work/Eats%20in%20the%20West/Water-Bottle-Mockup.jpg",
                      width: 6,
                      height: 5
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542887165/rtds_work/Eats%20in%20the%20West/Fries-Box-Mockup.jpg",
                      width: 5,
                      height: 4
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542888653/rtds_work/Eats%20in%20the%20West/Coffe_Cup_paper_OK_1.jpg",
                      width: 5,
                      height: 4
                    },
                  ],
                "features":[
                    {
                      id: 1,
                      desc:
                        "Redtomato Design Studio gave them a new brand identity which includes their new logo to be used in their utensils and kitchen ware and other disposables. Craving for that Filipino cuisine but have kids around who wants to eat fast food?  Stop by on their restaurant, Eats in the West!",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1542887165/rtds_work/Eats%20in%20the%20West/Fries-Box-Mockup.jpg"
                    },
                    {
                      id: 2,
                      desc:
                        "Because of Eats in the West delicious food their customers have grown in numbers with that we provided them their own system that will help them monitor their supplies and sales.",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1555216434/rtds_work/webmosystems/eats-f-1.jpg"
                    },
                    {
                      id: 3,
                      desc:
                        "While your chefs cook and your waiters serve, you can conveniently monitor Eats in the West anytime anywhere through an overview summary of what’s happening. Navigate and check orders if they are delivered properly.",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1555219096/rtds_work/webmosystems/eats-f-2-02.png"
                    },
                    {
                      id: 4,
                      desc:
                        "No need to worry on miscommunication between your kitchen and order takers! The system can conveniently take orders and communicate the order right at your kitchen door! Excited to let your customers taste your new recipe? Just add them on the menu!",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1555219095/rtds_work/webmosystems/eats-f-3.png"
                    }
                  ]
            },
            {
                "key": "mashiso",
                "name": "Mashiso",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1540402218/rtds_work/Logo/MashisoLogoMockup.jpg",
                "path": "/work/mashiso",
                "category":["branding","layout"],
                "desc": "Mashiso Korean BBQ is a new restaurant with one goal in mind – to provide customers the authentic Korean BBQ experience made from fresh ingredients, sauces and marinades that has been passed down from generations. As a new restaurant that wants to create their own name, Red Tomato Design Studio made the restaurant's identity. We made their new branding and their logos that was made to entice their customers into their eating into their mouth watering restaurant! Make sure to come and visit them for that Korean authentic experience!",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540405954/rtds_work/Banners/MashisoTarpMockUp2.jpg",
                      width: 5,
                      height: 7
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540402218/rtds_work/Logo/MashisoLogoMockup.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542891217/rtds_work/Mashiso/Free-Table-Paper-Napkin-Mockup-PSD.jpg",
                      width: 5,
                      height: 3
                    }
                  ],
                "features": [
                    {
                      id: 1,
                      desc:
                        "As a new restaurant that wants to create their own name, Red Tomato Design Studio made the restaurant's identity. We made their new branding and their logos that was made to entice their customers into their eating into their mouth watering restaurant! Make sure to come and visit them for that Korean authentic experience!",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1542868412/rtds_work/Mashiso/Mashiso-Tarp-1.jpg"
                    }
                  ]
            },
            {
                "key": "mck",
                "name": "MCK",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1540400341/rtds_work/Logo/MCKLogo_Mockup.jpg",
                "path": "/work/mck",
                "category":["branding","layout","photography"],
                "desc": "MCK Fresh Flowers is provides flowers in supermarkets and big malls like SM, Robinsons, Shopwise and Rustans. They sell fresh cut flowers local and imported. They make arrangements for any occasions and accepts flower delivery to selected locations. They are in need of marketing posters and an array of new flowers to be photographed. Redtomato Design Studio provided them with just what they need to boost their sales. If you are in need of fresh cut flowers, for your loved ones, a party or you want to start a flower buisiness of your own, then MCK Fresh Flowers is perfect for you!",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540406172/rtds_work/Business%20Collaterals/MCKBusiness-card-mockup.jpg",
                      width: 1,
                      height: 1
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540400341/rtds_work/Logo/MCKLogo_Mockup.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540480195/rtds_work/Posters/MCKPoster3-eMockup.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540409407/rtds_work/Posters/MCKPoster3-cMockup.jpg",
                      width: 4,
                      height: 4
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540409407/rtds_work/Posters/MCKPoster2-cMockup.jpg",
                      width: 4,
                      height: 4
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540409406/rtds_work/Posters/MCKPoster1-cMockup.jpg",
                      width: 4,
                      height: 4
                    }
                  ],
                "features": [
                    {
                      id: 1,
                      desc:
                        "If you are in need of fresh cut flowers, for your loved ones, a party or you want to start a flower business of your own, then MCK Fresh Flowers is perfect for you!",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1542865611/rtds_work/MCK/MCKPoster3-cMockup.jpg"
                    }
                ]
            },
            {
                "key": "thai-chix",
                "name": "Thai Chix",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1540403678/rtds_work/Logo/ThaiChixLogoMockup.jpg",
                "path": "/work/thai-chix",
                "category":["branding","illustrate"],
                "desc": "Thai Chix was founded by a group of university students, their goal was to have a food stall that sells delicious chicken dishes to those hungry students. Their university offers students to have their own stall in the campus but they would only provide limited number of official slots, therefore it is a competition to see who has the most profit before the contest ends. We helped Thai Chix to stand from the rest. From their logos, branding, posters,banners and stall design. With these they are sure to have the most attractive stall from the rest.",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1540403678/rtds_work/Logo/ThaiChixLogoMockup.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542868652/rtds_work/Thai%20Chix/ThaiChix_TentPhotos.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542881378/rtds_work/Thai%20Chix/PlateThaiChix.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542881068/rtds_work/Thai%20Chix/Mockup_Fence_Banner_2.jpg",
                      width: 5,
                      height: 4
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542868653/rtds_work/Thai%20Chix/ThaiChixTarpOnTentMockup.jpg",
                      width: 5,
                      height: 4
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542880925/rtds_work/Thai%20Chix/Mockup_Fence_Banner_1.jpg",
                      width: 5,
                      height: 4
                    }
                  ],
                "features": [
                    {
                      id: 1,
                      desc:
                        "We helped Thai Chix to stand from the rest. From their logos, branding, posters, banners and stall design.",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1542881378/rtds_work/Thai%20Chix/PlateThaiChix.jpg"
                    },
                    {
                      id: 2,
                      desc:
                        "With these they are sure to have the most attractive stall from the rest.",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1542897226/rtds_work/Thai%20Chix/Apron-mockup.jpg"
                    }
                  ]
            },
            {
                "key": "jessa18",
                "name": "Jessa 18",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1540407248/rtds_work/Invitations/Jessa18thInvi-Mockup.jpg",
                "path": "/work/jessa18",
                "category":["layout"],
                "desc": "This event is one of the important events that our clients will truly treasure. It's their daughter's 18th birthday and they want to give her the best birthday she will ever have. What is a party without its guests? Redtomato Design Studio made sure to provide them with the beautiful looking invitation letters that are to be handed out.",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542869350/rtds_work/Jessa's%2018th/Jessa18thInvi-Mockup.jpg",
                      width: 1,
                      height: 1
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542883614/rtds_work/Jessa's%2018th/Save-The-Date-Card.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542882315/rtds_work/Jessa's%2018th/Invitation-Card-_-Envelope.jpg",
                      width: 4,
                      height: 3
                    }
                  ],
                "features":[
                    {
                      id: 1,
                      desc:
                        "What is a party without its guests? Redtomato Design Studio made sure to provide them with the beautiful looking invitation letters that are to be handed out.",
                      img:
                        "https://res.cloudinary.com/doddfudab/image/upload/v1542882315/rtds_work/Jessa%27s%2018th/Invitation-Card-_-Envelope.jpg"
                    }
                  ]
            },
            {
                "key": "pwdo",
                "name": "Philippine Web Designers Organization",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1540479507/rtds_work/Stickers/PWDO2018-Logo-Mockup.jpg",
                "path": "/work/pwdo",
                "category":["layout","stickers"],
                "desc": "PWDO is a non-profit volunteer organization that aims to strengthen the community, champion excellence in crafting web user interfaces, and uplift the state of web design in the Philippines. We organize events to educate and sharpen the skills and professionalism of Filipino web designers and developers. In their every events they handle, they are happily giving out free stickers for their attendees, and that is where we come from, to provide them with those cool-looking stickers.",
                "photos": [
                    {
                      "src": "https://res.cloudinary.com/doddfudab/image/upload/v1540479508/rtds_work/Stickers/FFC2017-ThrowbackMockup.jpg",
                      "width": 3,
                      "height": 3
                    },
                    {
                      "src": "https://res.cloudinary.com/doddfudab/image/upload/v1540479507/rtds_work/Stickers/PWDO2018-Logo-Mockup.jpg",
                      "width": 3,
                      "height": 3
                    },
                    {
                      "src": "https://res.cloudinary.com/doddfudab/image/upload/v1540479509/rtds_work/Stickers/PWDO2018-Nametag-Mockup.jpg",
                      "width": 4,
                      "height": 3
                    },
                    {
                      "src": "https://res.cloudinary.com/doddfudab/image/upload/v1540479507/rtds_work/Stickers/KitStickerMockup.jpg",
                      "width": 5,
                      "height": 4
                    }
                ],
                "features":[
                  {
                    id: 1,
                    desc:
                      "They organize events to educate and sharpen the skills and professionalism of Filipino web designers and developers. In their every events they handle, they are happily giving out free stickers for their attendees, and that is where Redtomato Design Studio come from, to provide them with those cool-looking stickers.",
                    img:
                      "https://res.cloudinary.com/doddfudab/image/upload/v1540479508/rtds_work/Stickers/FFC2017-ThrowbackMockup.jpg"
                  }
                ]
            },
            {
                "key": "hestia",
                "name": "Hestia",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542912130/rtds_work/Hestia%20Hospice%20and%20Palliative%20Care/Hestia-Logo-Mock.jpg",
                "path": "/work/hestia",
                "category":["branding","layout"],
                "desc": "",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542912130/rtds_work/Hestia%20Hospice%20and%20Palliative%20Care/Hestia-Logo-Mock.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542906527/rtds_work/Hestia%20Hospice%20and%20Palliative%20Care/Hestia-Brochure.jpg",
                      width: 4,
                      height: 3
                    }
                  ]
            },
            {
                "key": "enovacore",
                "name": "Enovacore",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542911240/rtds_work/Enovacore/enovacore-logo-mock.jpg",
                "path": "/work/enovacore",
                "category":["branding","illustrate"],
                "desc": "",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542911240/rtds_work/Enovacore/enovacore-logo-mock.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542908160/rtds_work/Enovacore/Stationery-Mockup---Enovacore.jpg",
                      width: 4,
                      height: 3
                    }
                  ]
            },
            {
                "key": "geyserhome",
                "name": "Geyser Home",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542906482/rtds_work/Geyser%20Home/Geyser-Brochure.jpg",
                "path": "/work/geyserhome",
                "category":["branding","illustrate","layout"],
                "desc": "",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542911463/rtds_work/Geyser%20Home/geyser-logo-mock.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542906482/rtds_work/Geyser%20Home/Geyser-Brochure.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542911487/rtds_work/Geyser%20Home/Stationery-Mockup---Geyser.jpg",
                      width: 3,
                      height: 3
                    }
                  ]
            },
            {
                "key": "vpss",
                "name": "Viewpoint Security Systems",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542909248/rtds_work/Viewpoint%20Security%20Systems/Viewpoint-Logo.jpg",
                "path": "/work/vpss",
                "category":["branding","illustrate","layout"],
                "desc": "",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542909248/rtds_work/Viewpoint%20Security%20Systems/Viewpoint-Logo.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542909751/rtds_work/Viewpoint%20Security%20Systems/Viewpoint-Collaterals.jpg",
                      width: 3,
                      height: 3
                    }
                  ]
            },
            {
                "key": "modarosa",
                "name": "Moda Rosa",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542900636/rtds_work/Moda%20Rosa/ModaPouch.jpg",
                "path": "/work/modarosa",
                "category":["branding","illustrate","layout"],
                "desc": "",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542900633/rtds_work/Moda%20Rosa/Moda_WindowDisplay.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542908117/rtds_work/Moda%20Rosa/hanging-card-mockup.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542908613/rtds_work/Moda%20Rosa/Save-The-Date-Card.jpg",
                      width: 4,
                      height: 4
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542900636/rtds_work/Moda%20Rosa/ModaPouch.jpg",
                      width: 4,
                      height: 4
                    }
                  ]
            },
            {
                "key": "codec",
                "name": "Coder's Development Circle",
                "img": "https://res.cloudinary.com/doddfudab/image/upload/v1542864705/rtds_work/Logo/graphaddikt-com-free-business-card-mock-up-300-dpi.jpg",
                "path": "/work/codec",
                "category":["illustrate","layout"],
                "desc": "",
                "photos": [
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542884508/rtds_work/Codec/graphaddikt-com-free-business-card-mock-up-300-dpi.jpg",
                      width: 3,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542885990/rtds_work/Codec/Lanyard_Mockup_1.jpg",
                      width: 4,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542886044/rtds_work/Codec/Lanyard_Mockup_2.jpg",
                      width: 5,
                      height: 3
                    },
                    {
                      src: "https://res.cloudinary.com/doddfudab/image/upload/v1542885081/rtds_work/Codec/Letter-Paper-Presentation-Mockup.jpg",
                      width: 5,
                      height: 4
                    }
                  ]
            }
        ];


// WEBPACK FOOTER //
// ./src/utils/projects.js